<template>
  <div class="ui-table-wrapper">
    <div :class="['ui-table-container', { responsive }]">
      <div class="ui-table-header ui-table-row-flex ui-table-header-desktop">
        <div
            v-for="col in columns"
            :key="col.key"
            :class="`ui-table-cell col-${col.key}`"
            @click="col.sortable && toggleSort(col.key)"
            :role="col.sortable ? 'button' : undefined"
            :tabindex="col.sortable ? 0 : undefined"
            :aria-sort="getAriaSortForColumn(col)"
            @keydown.enter.prevent="col.sortable && toggleSort(col.key)"
            @keydown.space.prevent="col.sortable && toggleSort(col.key)"
        >
          <div class="ui-th-content">
            <span>{{ col.label }}</span>
            <span v-if="col.sortable" class="ui-sort-icon">
                {{ getSortIcon(col.key) }}
              </span>
          </div>
        </div>
        <div v-if="showActions" class="ui-table-cell col-actions" :style="{ width: actionsWidth }">
          <div class="ui-th-content">{{ actionLabel }}</div>
        </div>
      </div>

      <div class="ui-table-body">
        <div v-for="row in rows" :key="row[idKey]" class="ui-table-row ui-table-row-flex">
          <div
              v-for="col in columns"
              :key="col.key"
              :class="`ui-table-cell col-${col.key}`"
          >
            <slot :name="`cell-${col.key}`" :row="row">
              {{ row[col.key] }}
            </slot>
          </div>
          <div v-if="showActions"  class="ui-table-cell col-actions" :style="{ width: actionsWidth }">
            <slot name="actions" :row="row">
              <button type="button" class="ui-action-button" @click="$emit('action-click', row)">
                {{ actionLabel }}
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>

    <slot name="pagination"></slot>
  </div>
</template>

<script>
export default {
  name: 'UIDataTable',
  props: {
    columns: { type: Array, required: true },
    rows: { type: Array, required: true },
    idKey: { type: String, default: 'id' },
    showActions: { type: Boolean, default: false },
    actionLabel: { type: String, default: 'Ações' },
    sortKey: { type: String, default: '' },
    sortDirection: { type: Number, default: 1 },
    responsive: {type: Boolean, default: false},
    actionsWidth: {
      type: String,
      default: '120px'
    }
  },
  methods: {
    getAriaSortForColumn(col) {
      if (!col.sortable) return undefined;
      if (this.sortKey !== col.key) return 'none';
      return this.sortDirection === 1 ? 'ascending' : 'descending';
    },
    toggleSort(key) {
      this.$emit('sort-change', {
        key,
        direction: this.sortKey === key ? this.sortDirection * -1 : 1
      });
    },
    getSortIcon(key) {
      if (this.sortKey !== key) return '⇅';
      return this.sortDirection === 1 ? '↑' : '↓';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@src/design/ui-design/_variables.scss';

.ui-table-wrapper {
  @include ui-table-base-flex;
}

.responsive {
  overflow-x: auto;
}
</style>
